import { render } from "./AppTaskPreview.vue?vue&type=template&id=36b4c18d&scoped=true&ts=true"
import script from "./AppTaskPreview.vue?vue&type=script&lang=ts"
export * from "./AppTaskPreview.vue?vue&type=script&lang=ts"

import "./AppTaskPreview.vue?vue&type=style&index=0&id=36b4c18d&scoped=true&lang=css"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b4c18d"]])

export default __exports__